"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.currencyOptions = void 0;
exports.currencyOptions = {
    AU: ['100', '50', '20', '10', '5', '2', '1', '0.5', '0.2', '0.1', '0.05'],
    IN: ['2000', '500', '200', '100', '50', '20', '10', '5', '2', '1'],
};
//# sourceMappingURL=currencies.js.map